import {
	CHECKOUT_SUMMARY_REQUEST,
	CHECKOUT_SUMMARY_SUCCESS,
	CHECKOUT_SUMMARY_ERROR,
	CHECKOUT_SUMMARY_CLEAR,
	CHECKOUT_CLEAR_ACTION_DETAILS
} from 'actions/CheckoutActions/checkoutSummaryActions';
import {
	UPDATE_CHECKOUT_QUANTITY_REQUEST,
	UPDATE_CHECKOUT_QUANTITY_SUCCESS,
	UPDATE_CHECKOUT_QUANTITY_ERROR,
	REMOVE_CHECKOUT_ITEM_REQUEST,
	REMOVE_CHECKOUT_ITEM_SUCCESS,
	REMOVE_CHECKOUT_ITEM_ERROR,
	UPDATE_DELIVERY_PROMISE_REQUEST,
	UPDATE_DELIVERY_PROMISE_SUCCESS,
	UPDATE_DELIVERY_PROMISE_ERROR,
	UPDATE_CHECKOUT_EMAIL_REQUEST,
	UPDATE_CHECKOUT_EMAIL_SUCCESS,
	UPDATE_CHECKOUT_EMAIL_ERROR,
	CHANGE_DELIVERY_SLOT_REQUEST,
	CHANGE_DELIVERY_SLOT_SUCCESS,
	CHANGE_DELIVERY_SLOT_ERROR,
	APPLY_COINS_REQUEST,
	APPLY_COINS_SUCCESS,
	APPLY_COINS_ERROR,
	USE_GST_REQUEST,
	USE_GST_SUCCESS,
	USE_GST_ERROR
} from 'actions/CheckoutActions/checkoutEditActions';

import { INIT, SUCCESS, LOADING, ERROR } from 'utils/asyncStatusHelper';

const INITIAL_STATE = {
	asyncStatus: INIT
};

export default function summary(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case CHECKOUT_SUMMARY_REQUEST:
		case CHANGE_DELIVERY_SLOT_REQUEST:
		case UPDATE_CHECKOUT_QUANTITY_REQUEST:
		case REMOVE_CHECKOUT_ITEM_REQUEST:
		case UPDATE_DELIVERY_PROMISE_REQUEST:
		case UPDATE_CHECKOUT_EMAIL_REQUEST:
		case APPLY_COINS_REQUEST:
		case USE_GST_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING,
				initialCall: action.type === CHECKOUT_SUMMARY_REQUEST
			});
		case CHECKOUT_SUMMARY_SUCCESS:
		case CHANGE_DELIVERY_SLOT_SUCCESS:
		case UPDATE_CHECKOUT_QUANTITY_SUCCESS:
		case REMOVE_CHECKOUT_ITEM_SUCCESS:
		case UPDATE_DELIVERY_PROMISE_SUCCESS:
		case UPDATE_CHECKOUT_EMAIL_SUCCESS:
		case APPLY_COINS_SUCCESS:
		case USE_GST_SUCCESS:
			// TODO: remove this check after handling the empty response case in
			// action
			const checkoutSummary = action.data || {};
			return Object.assign(
				{},
				{
					asyncStatus: SUCCESS,
					initialCall: action.type === CHECKOUT_SUMMARY_SUCCESS,
					timeStamp: new Date().getTime(),
					...checkoutSummary
				}
			);
		case CHECKOUT_SUMMARY_ERROR:
		case CHANGE_DELIVERY_SLOT_ERROR:
		case UPDATE_CHECKOUT_QUANTITY_ERROR:
		case REMOVE_CHECKOUT_ITEM_ERROR:
		case UPDATE_DELIVERY_PROMISE_ERROR:
		case UPDATE_CHECKOUT_EMAIL_ERROR:
		case APPLY_COINS_ERROR:
		case USE_GST_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error,
				initialCall: action.type === CHECKOUT_SUMMARY_ERROR
			});
		case CHECKOUT_CLEAR_ACTION_DETAILS:
			return Object.assign({}, state, { actionDetails: {} });
		case CHECKOUT_SUMMARY_CLEAR:
			return INITIAL_STATE;
		default:
			return state;
	}
}
